module.exports = __webpack_public_path__ + "img/close_w.85c296df.svg";